import React from "react";
import { bubble as Menu } from "react-burger-menu";
import { Link } from "react-router-dom";
import "./SideBar.css";

const SideBar = () => {
  return (
    <Menu right>
      <Link className="menu-item" to="/solution">
        SOLUTIONS
      </Link>
      <br />
      <Link className="menu-item" to="/configurations">
        ABOUT
      </Link>
      <br />
      <Link className="menu-item" to="/services">
        SERVICES
      </Link>
      <br />
      <Link className="menu-item" to="/work">
        WORK
      </Link>
      <br />
      <Link className="menu-item" to="/stats">
        NEWS
      </Link>
      <br />
      <Link className="menu-item" to="/notification">
        CONTACT
      </Link>
    </Menu>
  );
};

export default SideBar;
